import { assertIsDefined } from "../../../tsutils/assertIsDefined";
import { IQuickSortState } from "../../IQuickSortState";
import { IQuickSortContext } from '../../IQuickSortContext';
import { QuickSortStep } from '../../enums/QuickSortStep';
import { QuickSortAssignPartitionIndexState } from "./QuickSortAssignPartitionIndexState";

export class PartitionReturnPivotPositionState implements IQuickSortState {
  
  ThisQuickSortStep = QuickSortStep.PartitionReturnPivot;

  Description = "Return pivot position after partition";

  private _context : IQuickSortContext | undefined;

  SetContext(context: IQuickSortContext): void {
    this._context = context;
  }  
  
  Do(): void {
    assertIsDefined(this._context);
    assertIsDefined(this._context.Numbers);
    assertIsDefined(this._context.AlgoStack);
    assertIsDefined(this._context.ICount);
   
    this._context.AlgoStack.push(this._context.ICount + 1);

    //
    // Will set Pivot, ICount and JCount to undefined (so you'll need them to restore state)
    //
  }

  Undo(): void {
    assertIsDefined(this._context);
    assertIsDefined(this._context.AlgoStack);
    
    this._context.AlgoStack.pop();
  }

  Exit(): void {
    assertIsDefined(this._context);
    this._context.TransitionTo(new QuickSortAssignPartitionIndexState());
  }
}